import { graphql } from "@/lib/gql/__generated__";

export const SnackList_SnackListPage_Query = graphql(`
	query SnackList_SnackListPage($hotelID: ID!) {
		snackList(hotelID: $hotelID) {
			id
			snacks {
				id
				uuid
				snackType
				hotelID
				ownerType
				isPublished
				isParentTemplate
				slug
				title
				description
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
				availablePlansForHotel
				createdAt
				updatedAt
			}
		}
		snackSettings(hotelID: $hotelID) {
			id
			hotelID
			subDomain
			baseDomain
			ownerType
			validDtEnd
			gtmID
		}
	}
`);
